<div class="ontario-row">
  <div class="ontario-column ontario-small-12">
      <p>{{ 'bss.notAuthorize.subTitle' | translate }}</p>
  </div>
</div>
